import { render, staticRenderFns } from "./Countup.vue?vue&type=template&id=64422b46"
import script from "./Countup.vue?vue&type=script&lang=js"
export * from "./Countup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports